import {observer} from "mobx-react";
import React, {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import CloseIcon from "@mui/icons-material/Close";
import {useStore} from "../../../stores/Store";

interface Props {
    buttonLabel?: string | undefined,
    buttonIcon: React.ReactNode
    buttonColor?: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info',
    buttonVariant?: 'outlined' | 'text' | 'contained',
    confirmationText: string,
    confirmationTitle: string,
    confirmCallback: () => void,
}

export default observer(function ConfirmationDialog({
    buttonLabel,
    buttonIcon,
    confirmCallback,
    buttonColor = 'secondary',
    buttonVariant = 'contained',
    confirmationTitle = 'Please Confirm',
    confirmationText = 'Are you sure?'
} : Props){
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { LanguageStore } = useStore();
    const { currentLanguageMessages } = LanguageStore;

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    const handleConfirm = () => {
        confirmCallback();
        handleClose();
    }

    return (
        <>
            {buttonLabel ?
                <Button
                    startIcon={buttonIcon}
                    color={buttonColor}
                    variant={buttonVariant}
                    onClick={handleOpen}
                >
                    {buttonLabel}
                </Button> :
                <IconButton
                    color={buttonColor}
                    onClick={handleOpen}
                >
                    { buttonIcon }
                </IconButton>
            }
            <Dialog open={isOpen}>
                <DialogTitle>{confirmationTitle}</DialogTitle>
                <DialogContent>{confirmationText}</DialogContent>
                <DialogActions>
                    <Grid container sx={{justifyContent: 'space-between', width: '100%'}}>
                        <Grid>
                            {
                                buttonLabel ?
                                    <Button
                                        startIcon={<CloseIcon />}
                                        onClick={handleClose}
                                        variant={buttonVariant}
                                    >
                                        {currentLanguageMessages.GeneralComponentLabels.cancelButtonLabel}
                                    </Button>
                                    :
                                    <IconButton
                                        onClick={handleClose}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                            }
                        </Grid>
                        <Grid>
                            {
                                buttonLabel ?
                                    <Button
                                        startIcon={buttonIcon}
                                        color={buttonColor}
                                        variant={buttonVariant}
                                        onClick={handleConfirm}
                                    >
                                        { buttonLabel }
                                    </Button> :
                                    <IconButton
                                        onClick={handleConfirm}
                                        color={buttonColor}
                                    >
                                        { buttonIcon }
                                    </IconButton>
                            }
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    )
})